import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  AttachmentButton,
  SendButton,
  InputToolbox,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useState } from "react";
import AWS from "aws-sdk";
import Swal from "sweetalert2";
export default function SalesChatSimulator({ title, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [displayText, setDisplayText] = useState("");
  // const [question, setQuestion] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [deleteError, setdeleteError] = useState("");
  // const [selectedModel, setSelectedModel] = useState("meta.llama2-13b-chat-v1");
  // const [modeltext, setModelText] = useState("LLAMA 13b");
  const timetaken = useRef(0);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [transcript, setTranScript] = useState("");

  useEffect(() => {
    if (transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleSendMessage = (messageText) => {
    // Create a new message object
    const newMessage = {
      id: Math.random().toString(), // Generate a unique ID for the message
      text: messageText,
      sender: "User",
      direction: "outgoing",
    };
    // Update the messages state by adding the new message
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    handleQuestion1(messageText);
  };

  const [chatPayload, setChatPayload] = useState({
    conversation_list: [],
    salesperson_response: "",
    status: false,
    message: "",
    conclusion: "",
  });

  const [isFirstRequest, setIsFirstRequest] = useState(true);

  const handleQuestion1 = async (question) => {
    setTranScript("");
    setDisplayText("");
    if (question.length > 0) {
      timetaken.current = 0;

      // Start the timer to track time taken for the request
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);

      setAnswerload(true);
      console.log("requesting");

      // Get the username and prepare the payload object
      const username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );

      // Collect the entire conversation history
      const conversation_list = Array.isArray(messages)
        ? messages.map((message) => message.text)
        : [];

      // Prepare payload as done in the handleCompare function
      // const payload = {
      //   conversation_list: conversation_list,
      //   salesperson_response: question,
      //   status: false,
      //   message: "",
      //   conclusion: "",
      //   // unasked_compulsory: "",
      //   // unasked_optional: ""
      // };

      let payload;
      if (isFirstRequest) {
        payload = {
          conversation_list: conversation_list,
          salesperson_response: question,
          status: false,
          message: "",
          conclusion: "",
        };
      } else {
        payload = {
          ...chatPayload,
          conversation_list: conversation_list,
          salesperson_response: question,
        };
      }

      console.log("Payload before sending:", payload);

      try {
        // Use fetch instead of XMLHttpRequest
        const response = await fetch(
          "https://dgguinjjudmi3zxvsncwpvpyri0epdrk.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );

        // Parse the response
        const data = await response.json();
        console.log("Response Data:", data);

        // Set the output and stop loading spinner
        setOutput(data);
        setAnswerload(false);

        // Extract message and conclusion from the response
        const chatbotMessage = data.message || "No message available";
        const chatbotConclusion = data.conclusion || "No conclusion available";

        if (data.status === true) {
          setIsInputDisabled(true);
          setTranScript("");
          setDisplayText("");
        }

        // Append the message to the Chatbot messages
        const newMessage = {
          id: Math.random().toString(), // Generate a unique ID for the message
          text: chatbotMessage,
          sender: "Chatbot",
          direction: "incoming",
        };

        clearInterval(time);
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        setTranScript(chatbotConclusion);

        setChatPayload({
          ...payload, // Keep the existing payload values
          message: "",
          conclusion: "",
          unasked_compulsory: data.unasked_compulsory || "",
          unasked_optional: data.unasked_optional || "",
          status: data.status,
        });

        // Mark that the first request is done
        setIsFirstRequest(false);
      } catch (error) {
        console.error("Error occurred during the request:", error);
        setAnswerload(false);

        // Handle any errors that occur during the fetch call
        const newMessage = {
          id: Math.random().toString(),
          text: "Something went wrong",
          sender: "Chatbot",
          direction: "incoming",
        };
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        clearInterval(time);
      }
    } else {
      setError("please enter question");
    }
  };

  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                  <Button  variant="contained" color="primary" >Home</Button>
                              </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div
          className="emailsum-container"
          style={{
            alignContent: "start",
            gap: "2rem",
            width: "95vw",
            fontFamily: "'Outfit', sans-serif",
          }}
        >
          <div
            className="result-chatbot"
            style={{ flex: "4", alignContent: "start", padding: "2rem 1.5rem" }}
          >
            {/* <h4>Chatbot</h4> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <h3>
                <strong>Chat Window</strong>
              </h3>
              {/* <Button variant="contained" color="primary" onClick={handleStart}>
                Start Chat
              </Button> */}
            </div>
            <div
              style={{
                position: "relative",
                height: "500px",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <MainContainer
                style={{
                  borderRadius: "1rem",
                  backgroundColor: "#F0F0F0",
                  color: "#333333",
                  fontFamily: "'Outfit', sans-serif",
                }}
              >
                <ChatContainer
                  style={{
                    padding: "0.5rem",
                    fontFamily: "'Outfit', sans-serif",
                    backgroundColor: "#F0F0F0",
                    fontSize: "1.05rem",
                  }}
                >
                  <MessageList
                    style={{
                      backgroundColor: "#F0F0F0",
                      color: "#333333",
                      fontFamily: "'Outfit', sans-serif",
                    }}
                    typingIndicator={
                      answerload && (
                        <TypingIndicator content="chatbot is typing" />
                      )
                    }
                    autoScrollToBottomOnMount={true}
                  >
                    {Array.isArray(messages) &&
                      messages.map((message) => (
                        <Message
                          model={{
                            message: message.text,
                            direction: message.direction,
                          }}
                        />
                      ))}
                  </MessageList>
                  <MessageInput
                    attachButton={false}
                    placeholder="Type message here"
                    onSend={handleSendMessage}
                    // disabled={isInputDisabled || transcript.length > 0}
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      borderRadius: "1rem",
                    }}
                  />
                  {/* <InputToolbox>
                        <AttachmentButton />
                        <SendButton />
                      </InputToolbox> */}
                </ChatContainer>
              </MainContainer>
            </div>
          </div>
          <div
            className="input-form-chatbot"
            style={{
              flex: "2.5",
              margin: "0",
              maxHeight: "700px",
              overflowY: "auto",
              padding: "2rem 3rem",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            <h3>
              <strong>Feedback Window</strong>
            </h3>
            <div
              className="section-container"
              style={{
                fontFamily: "'Outfit', sans-serif",
                color: "#333333",
                backgroundColor: "#F0F0F0",
              }}
            >
              <h4>
                <strong>Latest Response Feedback</strong>
              </h4>
              <hr style={{ background: "#333333" }}></hr>
              {displayText.length > 0 ? (
                <div
                  style={{
                    color: "#333333",
                    fontFamily: "'Outfit', sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayText }}
                ></div>
              ) : (
                "Response will be displayed here"
              )}
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
